export default "__VITE_ASSET__y9XJEOYf__"